import React from 'react'
import styled from 'styled-components'

const CLP = () => {
    const categories = ['Home', 'Fashion','Grocery','Fruits','Vegetables']
  return (
    <Container>
        {
            categories.map((item)=>  <div className='cat-item' onClick={()=>alert(item)}>{item}</div> )
        }

    </Container>

  )
}

const Container = styled.section`

/* background-color: red; */
width: 20%;
height: 100%;
padding: 1remm;
border: 1px solid black;
.cat-item{
    :hover{
        color: white;
        cursor: pointer
    }
}
`

export default CLP